
import * as auth from './auth/reducer'
import * as estado from './estado/reducer'
import * as cache from './cache/reducer'
import * as configuracion from './configuracion/reducer'
import * as configuracionesif from './definicionesif/reducer'
import *  as datosmaestros from './datosmaestros/reducer'

//Creamos un objeto combinando todos los reducers parciales.
let globalReducer = {}
Object.keys(auth).forEach(key => globalReducer[key] = auth[key]);
Object.keys(estado).forEach(key => globalReducer[key] = estado[key]);
Object.keys(cache).forEach(key => globalReducer[key] = cache[key]);
Object.keys(configuracion).forEach(key => globalReducer[key] = configuracion[key]);

Object.keys(configuracionesif).forEach(key => globalReducer[key] = configuracionesif[key]);
Object.keys(datosmaestros).forEach(key => globalReducer[key] = datosmaestros[key]);

console.log("globalReducer: ", globalReducer);

export default globalReducer;